module.exports = __webpack_public_path__ + "static/IMG_7887-f2618a5e561f8ca6de4b4ee55f80b102.jpg";